$(document).ready(function () {
  $('.js-toggle-chapter-details').click(function(event) {
    event.preventDefault();

    var this_chapter_exercises = $(this).parent().siblings('.chapter__exercises');
    if ( $(this).hasClass('chapter__footer-btn-link-view') ) {
      $(this).text('Hide Chapter Details');
    }
    else {
      $(this).text('View Chapter Details');
    }
    $(this).toggleClass('chapter__footer-btn-link-view');
    this_chapter_exercises.toggleClass('hidden');
  });
});
